import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n/LanguageProvider';
import { routesConfig } from '../../routes';

export default function NotFound() {
  const { isPortuguese, t } = useTranslation();
  const text = (pt, en) => isPortuguese ? pt : en;
  const destinations = routesConfig.filter(({ translationKey }) => translationKey);

  return (
    <section className="not-found">
      <p className="not-found-code">404</p>
      <h1 className="page-title">{text('Página não encontrada', 'Page not found')}</h1>
      <p className="not-found-lead">
        {text(
          'O endereço que você abriu não existe neste site. Ele pode ter mudado, ou o link que trouxe você até aqui pode estar incompleto.',
          'The address you opened does not exist on this site. It may have changed, or the link that brought you here may be incomplete.'
        )}
      </p>
      <nav aria-label={text('Seções do site', 'Site sections')}>
        <ul className="not-found-links">
          {destinations.map(({ path, translationKey }) => (
            <li key={path}><Link to={path}>{t(`nav.${translationKey}`)}</Link></li>
          ))}
        </ul>
      </nav>
    </section>
  );
}
